// @flow
// Bootstrap 5 plugins. Importing a plugin also enables its data-bs-* API.
// Call them through this module (or `window.bootstrap` in inline view
// scripts), e.g. `Tooltip.getOrCreateInstance(el, options)`, rather than the
// jQuery bridge, which goes away with jQuery.
import Carousel from 'bootstrap/js/dist/carousel'
import Collapse from 'bootstrap/js/dist/collapse'
import Dropdown from 'bootstrap/js/dist/dropdown'
import Modal from 'bootstrap/js/dist/modal'
import Popover from 'bootstrap/js/dist/popover'
import Tab from 'bootstrap/js/dist/tab'
import Tooltip from 'bootstrap/js/dist/tooltip'

const bootstrap = {Carousel, Collapse, Dropdown, Modal, Popover, Tab, Tooltip}

window.bootstrap = bootstrap

export {Carousel, Collapse, Dropdown, Modal, Popover, Tab, Tooltip}
export default bootstrap
